import { useState } from 'react';
import { Icon } from './Icon';

/** Shared read-only value with exact clipboard content and an accessible fallback. */
export function CopyableValue({ value, label }: { value: string; label: string }) {
  const [result, setResult] = useState<{ value: string; state: 'copied' | 'failed' } | null>(null);
  const state = result?.value === value ? result.state : null;
  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setResult({ value, state: 'copied' });
    } catch { setResult({ value, state: 'failed' }); }
  }
  return <div className="copyable-value">
    <code>{value}</code>
    <button className="button button--secondary" type="button" aria-label={`Copy ${label}`} onClick={() => void copy()}>
      <Icon name={state === 'copied' ? 'check' : 'clipboard'} size={16} />{state === 'copied' ? 'Copied' : 'Copy'}
    </button>
    <span className={state === 'failed' ? 'copyable-value__error' : 'sr-only'} role="status">{state === 'failed' ? 'Copy failed. Select and copy the value manually.' : state === 'copied' ? `${label} copied.` : ''}</span>
  </div>;
}
